import { PropType, reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { toggleGlobalListener, useResponsive } from '@orion.ui/orion';

type Props = SetupProps<typeof ModalOtpSetupService.props>
type OtpOnSuccessPayload = Event & {
	data?: {
		success?: boolean
		status?: string
		source?: string
	}
}

export default class ModalOtpSetupService extends BaseSetupService<Props> {
	static readonly props = {
		procedure: {
			type: String,
			default: null,
		},
		ids: {
			type: Array as PropType<number[]>,
			default: () => [],
		},
	};

	readonly _iframe = ref<HTMLElement>();
	readonly _modal?: OrionModal;

	private globalListenerId?: number;
	private readonly state = reactive({
		errorMessage: null,
		heightIframe: 'calc(100vh - 225px)', //TODO: rem ?
		status: undefined as Undef<string>,
	});

	get errorMessage () { return this.state.errorMessage;}
	get heightIframe () { return this.state.heightIframe;}

	get OtpResult () {
		switch (this.state.status) {
		case 'ok':
			return 'ok';
		case 'cancel':
		default: return 'cancel';
		}
	}


	constructor (props: Props, _modal?: OrionModal) {
		super(props);
		this._modal = _modal;
	}

	protected onMounted () {
		this.initComForIframe();
		if (useResponsive().onPhone) {
			this.state.heightIframe = 'calc(100vh - 250px)';
		}
	}


	onSuccess (event: OtpOnSuccessPayload) {
		if (event.data?.source !== 'vue-devtools-backend') {
			const data = event.data;
			if (data?.success) {
				const iframe = this._iframe.value;
				if (iframe) iframe.style.height = '5rem';
				if (this._modal) this._modal.options.size = 'sm';
				this.state.status = data.status;
				this._modal?.trigger('signed', this.props.ids.map(id => ({
					id,
					status: this.state.status === 'ok',
				})));
				if (this.globalListenerId) {
					toggleGlobalListener(this.globalListenerId);
					this.globalListenerId = undefined;
				}
			}


		}
	}

	initComForIframe () {
		this.globalListenerId = toggleGlobalListener(
			'message',
			this.onSuccess.bind(this),
			{ target: 'window' },
		);
	}
}
